var map = {
	"./_ar/ar.svg": "1617",
	"./_br/br.svg": "25da",
	"./_ch/ch.svg": "b0b7",
	"./_co/co.svg": "b62f",
	"./_ec/ec.svg": "4050",
	"./_mx/mx.svg": "862e",
	"./_pa/pa.svg": "7d77",
	"./_pe/pe.svg": "b3aa",
	"./_py/py.svg": "52ee",
	"./_uy/uy.svg": "1aeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c61c";